import { css } from 'styled-components'

import { helpers } from 'styles'

type Props = {
	hasError: boolean
	isDisabled: boolean
	isFocused: boolean
	isHovered: boolean
	isReadOnly: boolean
}

export const inputStyles = css<Props>`
	/* Avoid box-shadow being omitted on iOS Safari */
	appearance: none;
	background-color: ${({ isDisabled, isReadOnly, theme }) => (isDisabled || isReadOnly ? theme.color.input.backgroundDisabled : theme.color.input.background)};
	border: 1px solid ${({ isHovered, isFocused, isDisabled, isReadOnly, hasError, theme }) => {
		if (isFocused && !isDisabled && !isReadOnly) return 'transparent'
		if (isHovered && !isDisabled && !isReadOnly)
			return hasError ? theme.color.input.borderError : theme.color.input.border
		return hasError ? theme.color.input.borderError : theme.color.input.border
	}};
	box-shadow: ${({ hasError, isDisabled, isFocused, isReadOnly, theme }) => {
		if (!isDisabled && !isReadOnly && isFocused)
			return hasError ? `0 0 0 1px ${theme.color.input.borderError} ` : `0 0 0 1px ${theme.color.input.borderHover}`
		return 'none'
	}};
	border-radius: 4px;
	color: ${({ theme, isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? theme.color.input.contentDisabled : theme.color.input.content)};
	display: block;
	font: ${helpers.fonts.input.content};
	line-height: 1.2;
	margin: 0 0 -5px;
	outline: 0;
	padding: 16px;
	min-height: 56px;
	position: relative;
	text-align: left;
	transition: border 135ms ease, box-shadow 135ms ease, color 135ms ease;
	-webkit-tap-highlight-color: transparent;
	width: 100%;
	cursor: ${({ isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? 'auto' : 'text')};


	&::placeholder {
		color: ${({ hasError, theme }) => (hasError ? theme.color.input.placeholder : theme.color.input.placeholderError)};
	}

	/* Hides number arrows in Chromium and Safari */
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		display: none;
	}

	/* Hides number arrows in Firefox */
	&[type=number] {
		-moz-appearance: textfield; /* stylelint-disable-line */
	}
	/* Proper internal styling for safari date field */
	&::-webkit-date-and-time-value {
		text-align: left;
		min-height: 1.2em;
	}
`
